import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { ToastState } from '../../hooks/useToast';

interface ToastNotificationProps {
    toast: ToastState;
    onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
    autoHideDuration?: number;
    anchorVertical?: 'top' | 'bottom';
    anchorHorizontal?: 'left' | 'center' | 'right';
}

/**
 * Единый компонент для отображения уведомлений
 * Использует консистентное положение и стиль на всех страницах
 *
 * @example
 * const { toast, handleClose } = useToast();
 *
 * <ToastNotification toast={toast} onClose={handleClose} />
 */
export const ToastNotification: React.FC<ToastNotificationProps> = ({
    toast,
    onClose,
    autoHideDuration = 6000,
    anchorVertical = 'top',
    anchorHorizontal = 'right'
}) => {
    return (
        <Snackbar
            open={toast.open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={{
                vertical: anchorVertical,
                horizontal: anchorHorizontal
            }}
        >
            <Alert
                onClose={onClose}
                severity={toast.severity}
                sx={{ width: '100%', whiteSpace: 'pre-line' }}
                variant="filled"
            >
                {toast.message}
            </Alert>
        </Snackbar>
    );
};
